import React from 'react'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import {
	Typography,
	FormControl,
	TextField,
	FormControlLabel,
	Switch
} from '@material-ui/core'
import { DatePicker } from "@material-ui/pickers"
import ImageLoader from './../../containers/modules/ImageLoader'
import { Mcedit } from '../../containers/modules/Mcedit'
import { get_query, post_query } from './../../functions'

const initState = {
	title: '',
	engurl: '',
	viewdate: moment(),
	viewrecord: false,
	preimg: '',
	content: ''
}

// new blog record
class OpportunesEdit extends React.Component {
	constructor(props){
		super(props)
		this.state = {
			loader: false
		}
	}

	UNSAFE_componentWillMount(){
		this.setState(Object.assign({}, this.state, initState))
	}

	componentDidMount(){
		this.getData()
	}

	getData(){
		this.setState({ loader: true })
		let id = this.props.match.params.id
		get_query(`/api/opportunes/${id}`)
		.then((res) => {
			this.setState({
				id: res.id,
				title: res.title,
				engurl: res.engurl,
				preimg: res.preimg,
				viewdate: res.viewdate ? moment(res.viewdate, 'YYYY-MM-DD HH:mm:ss') : false,
				viewrecord: res.viewrecord,
				loader: false,
				content: res.content
			})
		})
		.catch((err) => {
			this.setState({ loader: true })
		})
	}

	// save record data
	saveData(content){
		this.setState({ loader: true })
		let data = {
			id: this.state.id,
			viewrecord: this.state.viewrecord,
			title: this.state.title,
			viewdate: this.state.viewdate.unix(),
			preimg: this.state.preimg,
			engurl: this.state.engurl,
			content: content
		}
		post_query('/api/opportunes/update', data)
		.then((res) => {
			this.props.history.push(`/opportunes`)
		})
		.catch((err) => {
			this.setState({ loader: false })
		})
	}

	render(){
		return(
			<>
				<Typography variant='h4'>
					Редактировать возможность
				</Typography>
				<div className='div-flex-row'>
					<div
						style={{ padding: 16 }}
					>
						<ImageLoader 
							width={300}
							height={300}
							img={this.state.preimg}
							upload={(l) => this.setState({ preimg: l })}
						/>
					</div>
					<div className='fields'>
						<div>
							<FormControl
								className='form-item'
							>
								<TextField 
									inputProps={{style:{ width: 700 }}}
									label='Подпись категории'
									value={this.state.title}
									onChange={(ev) => this.setState({ title: ev.target.value })}
								/>
							</FormControl>
						</div>
						<div>
							<FormControl
								className='form-item'
							>
								<TextField 
									inputProps={{style:{ width: 700 }}}
									label='Eng наименование в URL'
									value={this.state.engurl}
									onChange={(ev) => this.setState({ engurl: ev.target.value })}
								/>
							</FormControl>
						</div>
						<div>
							<FormControl
								className='form-item'
							>
								<DatePicker
									openTo="year"
									format="DD-MM-YYYY"
									label="Начало действия"
									views={["date"]}
									value={this.state.viewdate}
									onChange={(viewdate) => this.setState({ viewdate: viewdate })}
								/>
							</FormControl>
						</div>
						<div>
							<FormControlLabel
								value='start'
								control={
									<Switch 
										color="primary" 
										checked={this.state.viewrecord}
										onChange={(ev) => this.setState({ viewrecord: ev.target.checked })}
									/>
								}
								label={this.state.viewrecord ? 
									<p style={{width: 120}}>Показано</p> : 
									<p style={{width: 120}}>Скрыто</p>
								}
								labelPlacement="start"
							/>
						</div>
					</div>
				</div>
				<Mcedit
					loader={this.state.loader}
					initialValue={this.state.content}
					goBack={() => this.goBack()}
					saveAction={(c) => this.saveData(c)}
				/>
			</>
		)
	}
}

export default withRouter(OpportunesEdit)


